var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-container{height:1.2rem;background:#fff;width:100%;display:flex;display:-webkit-flex}.report-container .report-item{text-align:center;flex:1;line-height:1.2rem;width:50%}.report-container .report-label{display:inline-block;height:100%;padding:0 .533333rem}.report-container .report-label.active{color:#39c451;border-bottom:.053333rem solid #39c451}.right-txm{width:1rem;position:absolute;top:0;bottom:0;right:.8rem;background:url(" + escape(require("../../../static/img/qr-code.png")) + ") no-repeat 50%;background-size:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17ee01c9","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/myreport/MyReport.vue
// module id = 416
// module chunks = 0